module.exports = __webpack_public_path__ + "static/img/11lizhixiaofei.4d53b443.gif";